import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, concatMap, mergeMap } from 'rxjs/operators';
import { Observable, EMPTY, of } from 'rxjs';
import { HistoryLogQualitativeActions } from './history-log-qualitative.actions';
import { HistoryLogQualitativeService } from '../../service/history-log-qualitative.service';


@Injectable()
export class HistoryLogQualitativeEffects {

loadQualitativeHistoryLog$ = createEffect(
        (rs: HistoryLogQualitativeService = inject(HistoryLogQualitativeService)) => {
            return this.actions$.pipe(

                ofType(HistoryLogQualitativeActions.loadQualitativeHistoryLog),
                mergeMap(({ parameters, legalEntityId, campaignId }) =>
                    rs.fetchQualitativeHistoryLog(parameters, legalEntityId, campaignId).pipe(
                        map((historyLog) => {
                            return HistoryLogQualitativeActions.loadQualitativeHistoryLogSuccess({
                                historyLog
                            });
                        }),
                        catchError((error) => of(HistoryLogQualitativeActions.loadQualitativeHistoryLogFailure({ error })))
                    )
                )
            );
        },
        { functional: true }
    );

  constructor(private actions$: Actions) {}
}
